<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-create-update-class-school"
            @hidden="resetModal">

            <div class="container wrap-form-save-class-school">
                <h4>
                    <strong>{{ getNameTitle }}</strong>
                </h4>
                <b-form id="form-save-class-school" @submit.prevent="handleSave">
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Tên {{ getNameType }}:</label>
                                <b-form-input id="name" v-model="form.name" type="text"
                                    :placeholder="`Nhập tên ${getNameType}`" autocomplete="off" class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.name.required && submitted">
                                    Vui lòng nhập tên {{ getNameType }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Bộ sách:</label>
                                <b-form-select v-model="form.bookTypeId" :options="listBookType" class="custom-select">
                                    <!-- <option value="">Chọn bộ sách</option> -->
                                </b-form-select>
                                <!-- <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.bookTypeId.required && submitted">
                                    Vui lòng chọn bộ sách
                                </span> -->
                            </div>
                        </div>
                    </div>
                    <div class="row form-group pb-2">
                        <div class="col-md-4 padding-right-5">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Khối lớp:</label>
                                <b-form-select v-model="form.classId" :options="listDataClass" class="custom-select">
                                    <!-- <option value="">Chọn lớp học</option> -->
                                </b-form-select>
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.classId.required && submitted">
                                    Vui lòng chọn lớp
                                </span>
                            </div>
                        </div>
                        <div class="col-md-4 padding-right-5">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Môn học:</label>
                                <b-form-select v-model="form.subjectId" :options="listDataSubject"
                                    class="custom-select">
                                    <!-- <option value="">Chọn môn học</option> -->
                                </b-form-select>
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.subjectId.required && submitted">
                                    Vui lòng chọn môn học
                                </span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="login-modal__form__item display-block">
                                <label for="numberLesson">Số tiết học:</label>
                                <b-form-input id="numberLesson" v-model="form.numberLesson" type="number"
                                    placeholder="Nhập số tiết" autocomplete="off" class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.numberLesson.required && submitted">
                                    Vui lòng nhập số tiết
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="description">Mô tả {{ getNameType }}:</label>
                                <b-form-input id="description" v-model="form.description" type="text"
                                    :placeholder="`Nhập mô tả ${getNameType}`" autocomplete="off"
                                    class="form-control" />

                            </div>
                        </div>
                    </div>
                    <div class="form_action display-flex justify-content-center">
                        <button type="button"
                            class="btn border-rd-20 margin-30 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy bỏ
                        </button>
                        <button type="submit"
                            class="btn btn-main margin-30 border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isDisabledSave">
                            {{ lessonId > 0 ? 'Cập nhật' : 'Thêm mới' }}
                        </button>
                    </div>
                </b-form>
            </div>

        </b-modal>
    </div>
</template>

<script>
import { getAllTypeFilter, getAllClassFilter } from './../../_api/'
import { required } from 'vuelidate/lib/validators';
import { saveLessonClassSchool, getDetail } from './../../_api/LessonClassSchoolServices'

import { PLANING_LESSON_WAREHOUSE, ELECTRONIC_LECTURE_WAREHOUSE } from './../../constants/constants_enum'

export default {
    name: "ModalCreateUpdateClassSchool",
    props: {
        lessonId: {
            type: Number,
            default: 0
        },
        type: {
            type: Number,
            default: 0
        }
    },
    components: {

    },
    watch: {
        'form.classId': 'getTypesFilter'
    },
    data() {
        return {
            isDisabledSave:false,
            PLANING_LESSON_WAREHOUSE,
            ELECTRONIC_LECTURE_WAREHOUSE,
            confirmActive: {},
            submitted: false,
            isLoading: false,
            listDataSubject: [{ value: 0, text: 'Chọn môn học' }],
            listDataClass: [{ value: 0, text: 'Chọn lớp học' }],
            listBookType: [{ value: 0, text: 'Chọn bộ sách' }],
            form: {
                id: 0,
                name: '',
                bookTypeId: 0,
                classId: 0,
                subjectId: 0,
                numberLesson: '',
                description: '',
                type: this.type
            }
        }
    },
    validations() {
        return {
            form: {
                numberLesson: {
                    required
                },
                name: {
                    required
                },
                // bookTypeId: {
                //     required,
                // },
                subjectId: {
                    required
                },
                classId: {
                    required
                }
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        getNameTitle() {
            if (this.type == ELECTRONIC_LECTURE_WAREHOUSE) {
                return this.lessonId == 0 ? 'Thêm bài giảng' : 'Cập nhật bài giảng'
            }
            else if (this.type == PLANING_LESSON_WAREHOUSE) {
                return this.lessonId == 0 ? 'Thêm kế hoạch bài dạy' : 'Cập nhật kế hoạch bài dạy'
            }
            return ''
        },
        getNameType() {
            if (this.type == ELECTRONIC_LECTURE_WAREHOUSE) {
                return 'bài giảng điện tử'
            }
            else if (this.type == PLANING_LESSON_WAREHOUSE) {
                return 'kế hoạch bài dạy'
            }
            return ''
        }
    },
    mounted() {
        //this.getTypesFilter()
        this.GetAllClass()
        this.handleShowModal()
        if (this.lessonId > 0) {
            this.getDetailLessonClassSchool()
        }
        if (this.lessonId == 0) {

        }
    },

    methods: {

        getDetailLessonClassSchool() {
            let self = this
            getDetail(this.lessonId).then(res => {
                if (res && res.data && !res.errors) {
                    self.form = {
                        id: res.data.id,
                        name: res.data.name,
                        bookTypeId: res.data.bookTypeId,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,
                        numberLesson: res.data.numberLesson,
                        description: res.data.description,
                        type: res.data.type,
                    }
                }
            })
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        handleSave() {
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {
                self.isDisabledSave = true
                saveLessonClassSchool(this.form).then(res => {
                    if (res && res.data && !res.errors) {
                        self.$toast.success('Thêm bài giảng điện tử thành công')
                        this.handleDone()
                        if (this.type == 4) {
                            // mở tab mới
                            window.open('/kho-ke-hoach-bay-day/ke-hoach-bai-day?id=' + res.data.id + '&name=' + res.data.name + '&isEdit=1', '_blank');
                            // không mở tab mới
                            // this.$router.push({
                            //     path: "/kho-ke-hoach-bay-day/ke-hoach-bai-day",
                            //     query: { id: res.data.id, name: res.data.name, isEdit: 1 }
                            // });

                        }
                        else if (this.type == 2) {
                            // this.$router.push({
                            //     path: "/kho-bai-giang/bai-giang-dien-tu",
                            //     query: { id: res.data.id, name: res.data.name, isEdit: 1 }
                            // });
                            window.open('/kho-bai-giang/bai-giang-dien-tu?id=' + res.data.id + '&name=' + res.data.name + '&isEdit=1', '_blank');
                        }
                        self.isDisabledSave = false
                    }
                })
            }

        },
        resetModal() {
            console.log('resetModal')
            this.submitted = false
            this.form = {
                id: 0,
                name: '',
                bookTypeId: '',
                classId: '',
                subjectId: '',
                numberLesson: '',
                description: '',
                type: 2

            }
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-create-update-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-create-update-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-create-update-class-school'].show()
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = []
            self.listBookType = []
            self.listDataSubject.push({ value: '', text: 'Chọn môn học' })
            self.listBookType.push({ value: '', text: 'Chọn bộ sách' })
            getAllTypeFilter({ classId: this.form.classId }).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                    for (let i = 0; i < res.data.ltsBookType.length; i++) {
                        const item = res.data.ltsBookType[i];
                        self.listBookType.push({ value: item.bookGroupId, text: item.name })
                    }
                }
            })
        },
        GetAllClass() {
            let self = this
            self.listDataClass = []
            self.listDataClass.push({ value: 0, text: 'Chọn lớp học' })
            getAllClassFilter({}).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name })
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    background-color: red;
}

.wrap-form-save-class-school {
    padding-top: 20px;
    background-color: white;

}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}

.justify-content-center {
    justify-content: center
}

.margin-30 {
    margin: 0 30px;
}

.btn.btn-main {
    padding: 5px 30px;
}

.padding-right-5 {
    @media screen and (min-width: 768px) {
        padding-right: 5px;
    }
}
</style>